import React, { use, useMemo, type PropsWithChildren } from 'react'
import { useAuthedFetch } from '@/hooks/useAuthedFetch'
import { genericMemo } from '@/components/genericMemo'
import { AguiService } from './api'

const defaultApi = new AguiService('localhost:8000', fetch)

const ThreadServiceContext = React.createContext(defaultApi)

interface ThreadServiceProviderProps {
    apiUrl: string
}

export const ThreadServiceProvider: React.FC<
    PropsWithChildren<ThreadServiceProviderProps>
> = genericMemo(({ apiUrl, children }) => {
    const authedFetch = useAuthedFetch()
    const newApi = useMemo(
        () => new AguiService(apiUrl, authedFetch),
        [apiUrl, authedFetch]
    )

    return (
        <ThreadServiceContext value={newApi}>{children}</ThreadServiceContext>
    )
})

export const useThreadService = (): AguiService => use(ThreadServiceContext)
